










import { Component, Vue } from 'vue-property-decorator';
import ProcessNumberBase from '@/components/organizationDashboard/processNumber/ProcessNumberBase.vue';
import ProjectManagementBase from '@/components/organizationDashboard/projectManagement/ProjectManagementBase.vue';
import PerformanceBase from '@/components/organizationDashboard/performance/PerformanceBase.vue';
import EachProjectBase from '@/components/organizationDashboard/eachProject/EachProjectBase.vue';
import ProcessGraphBase from '@/components/organizationDashboard/processGraph/ProcessGraphBase.vue';
import { RepositoryFactory } from '@/repository//factory/repositoryFactory';
import { OrganizationsRepository } from '@/repository/repositories/theoryApi/organizations.repository';
import { AggregationResults, AllProjectCostAggregationResults } from '@/@types/Organization';
import { vxm } from '@/store';

@Component({
  components: {
    ProcessNumberBase,
    ProjectManagementBase,
    PerformanceBase,
    EachProjectBase,
    ProcessGraphBase,
  },
})
export default class OrganizationDashboardBase extends Vue {
  private organizationsRepository: OrganizationsRepository = RepositoryFactory.theoryApi.organizationsRepository();
  private organizationAggregationResults: AggregationResults[] = [];
  private allProjectCostAggregationResults: AllProjectCostAggregationResults[] = [];

  private async created() {
    const organizationCostAggregationResponse = await this.organizationsRepository.fetchOrganizationCostAggregations(this.organizationId);
    const allProjectCostAggregationResponse = await this.organizationsRepository.fetchAllProjectCostAggregations(this.organizationId);

    if (organizationCostAggregationResponse) {
      this.organizationAggregationResults = organizationCostAggregationResponse;
    }

    if (allProjectCostAggregationResponse) {
      this.allProjectCostAggregationResults = allProjectCostAggregationResponse;
    }
  }

  private get organizationId() {
    return vxm.theoryApi.authStore.getCurrentOrganizationId as number;
  }
}
